// Single source for UUID-shape validation. Used by route components to
// short-circuit invalid `:subjectId` / `:lessonId` / `:postId` params
// BEFORE firing RPCs — prevents the 400-from-PostgREST cascade and the
// resulting React error boundary on URLs like
// `/classroom/course/not-a-uuid`.
const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isValidUuid(value: string | null | undefined): value is string {
  if (!value) return false;
  return UUID_RE.test(value);
}
